import type { ReactElement } from 'react';
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Loading from 'atom-components/loading';
import { useAuth } from 'services/providers/auth.provider';

export default function AuthenticatedRoutes({ redirectPath = '/login' }): ReactElement {
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuth();

  /* if loading don't render routes yet */
  if (isLoading) {
    return <Loading />;
  }

  /* if not authorised and auth state is determined redirect to base route */
  if (!isAuthenticated) {
    return <Navigate to={redirectPath} state={{ from: location }} replace />;
  }

  /* render child routes */
  return <Outlet />;
}
